export type ScheduleStartupErrorSource = {
  startupError?: string | null
  updatedAt?: string | null
}

function parseLocalTimestamp(value: string): number | null {
  const match = value.match(
    /拦截时间[:：]\s*(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?/
  )
  if (!match) {
    return null
  }
  const [, year, month, day, hour, minute, second, millisecond = '0'] = match
  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second),
    Number(millisecond.padEnd(3, '0'))
  ).getTime()
}

/** 配置在拦截后又保存过时，旧 startupError 已经过期，不再展示。 */
export function isCurrentScheduleStartupError(task: ScheduleStartupErrorSource): boolean {
  const startupError = task.startupError?.trim()
  if (!startupError) {
    return false
  }
  const interceptedAt = parseLocalTimestamp(startupError)
  const updatedAt = task.updatedAt ? new Date(task.updatedAt).getTime() : Number.NaN
  if (interceptedAt == null || !Number.isFinite(updatedAt)) {
    return true
  }
  // 同一次持久化会产生毫秒级差异；超过 2 秒视为配置后来又保存过。
  return updatedAt <= interceptedAt + 2_000
}

/**
 * 启动请求失败后，只有后端确实写入了本次新拦截，才切换到第 5 步持久化展示；
 * 网络、认证等未落库错误仍沿用普通错误处理。
 */
export function didScheduleStartupErrorRefresh(
  current: ScheduleStartupErrorSource | null | undefined,
  previous: ScheduleStartupErrorSource | null | undefined
): boolean {
  if (current == null || !isCurrentScheduleStartupError(current)) {
    return false
  }
  return current.startupError !== previous?.startupError
    || current.updatedAt !== previous?.updatedAt
}
